/* eslint-disable react/require-default-props */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  Button,
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { brown, green, grey, pink, blue } from "@material-ui/core/colors";
import {
  ArrowBack,
  ArrowForward,
  BlurCircular,
  Business,
  CallEnd,
  Clear,
  Computer,
  Equalizer,
  FiberManualRecord,
  FiberManualRecordTwoTone,
  FilterList,
  List,
  MicNone,
  MicOff,
  MicRounded,
  OpenInNew,
  People,
  PeopleOutline,
  PersonOutline,
  Phone,
  PhoneInTalk,
  RingVolume,
  Security,
  SettingsOutlined,
  Voicemail,
} from "@material-ui/icons";
import React, { SetStateAction, useEffect, useState } from "react";
import { CXAgent } from "../CxDashboard";
import { StarSVG } from "../SAI/Sai";
import { deleteCookie } from "./Auth";
// import SaiLogo_dark from "../icons/sai2_dark.svg";
// import SaiLogo_light from "../icons/sai2_light.svg";

const SvgLight = () => {
  return (
    <svg
      id="eoqWGVh3rxu1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 40 40"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="aa417334ced04ba29c3f9ca876131d59"
      export-id="a24bc8c5daad4d2e8bccb943f660eed4"
      width="25"
      height="25"
    >
      <defs>
        <linearGradient
          id="eoqWGVh3rxu2-fill"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="eoqWGVh3rxu2-fill-0" offset="0%" stopColor="#86ccf8" />
          <stop id="eoqWGVh3rxu2-fill-1" offset="59%" stopColor="#e2c9f8" />
        </linearGradient>
        <linearGradient
          id="eoqWGVh3rxu3-fill"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="eoqWGVh3rxu3-fill-0" offset="22%" stopColor="#86ccf8" />
          <stop id="eoqWGVh3rxu3-fill-1" offset="100%" stopColor="#e2c9f8" />
        </linearGradient>
      </defs>
      <path
        d="M4.43716,24.79319c0-3.20329.75308-6.23069,2.09184-8.91482l2.76791.98787.56139,2.412274c-1.51541,2.81693-2.42114,5.091916-2.42114,8.514676c0,4.75872,1.66198,9.12926,4.43716,12.56284-4.53628-3.66642-7.43716-9.27587-7.43716-15.56284Zm20-20c6.28698,0,11.89642,2.90088,15.56284,7.43716-3.43358-2.77518-7.80413-4.43716-12.56284-4.43716-3.36183,0-5.620976,1.321798-8.401856,2.787238L16.63921,9.55733l-.96619-2.74666c2.64654-1.29226,5.62065-2.01748,8.76414-2.01748Z"
        fill="url(#eoqWGVh3rxu2-fill)"
        strokeWidth="0"
      />
      <polygon
        points="-0.724447,-8.124307 1.211574,-2.17862 6.675412,-0.071863 1.211574,2.034893 -0.724447,7.980581 -2.660468,2.034893 -8.124307,-0.071863 -2.660468,-2.17862 -0.724447,-8.124307"
        transform="matrix(1.351373 0.003079-.00283 1.241856 14.001556 13.294152)"
        fill="url(#eoqWGVh3rxu3-fill)"
        strokeWidth="0"
      />
    </svg>
  );
};

const SvgDark = () => {
  return (
    <svg
      id="e6yrOKULG4B1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 40 40"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="aa417334ced04ba29c3f9ca876131d59"
      export-id="497f6412a7a342c1ada31cf807274978"
      width="25"
      height="25"
    >
      <defs>
        <linearGradient
          id="e6yrOKULG4B2-fill"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e6yrOKULG4B2-fill-0" offset="0%" stopColor="#135d8b" />
          <stop id="e6yrOKULG4B2-fill-1" offset="59%" stopColor="#9411da" />
        </linearGradient>
        <linearGradient
          id="e6yrOKULG4B3-fill"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e6yrOKULG4B3-fill-0" offset="23%" stopColor="#135d8b" />
          <stop id="e6yrOKULG4B3-fill-1" offset="100%" stopColor="#9411da" />
        </linearGradient>
      </defs>
      <path
        d="M4.43716,24.79319c0-3.20329.75308-6.23069,2.09184-8.91482l2.76791.98787.56139,2.412274c-1.51541,2.81693-2.42114,5.091916-2.42114,8.514676c0,4.75872,1.66198,9.12926,4.43716,12.56284-4.53628-3.66642-7.43716-9.27587-7.43716-15.56284Zm20-20c6.28698,0,11.89642,2.90088,15.56284,7.43716-3.43358-2.77518-7.80413-4.43716-12.56284-4.43716-3.36183,0-5.620976,1.321798-8.401856,2.787238L16.63921,9.55733l-.96619-2.74666c2.64654-1.29226,5.62065-2.01748,8.76414-2.01748Z"
        fill="url(#e6yrOKULG4B2-fill)"
        strokeWidth="0"
      />
      <polygon
        points="-0.724447,-8.124307 1.211574,-2.17862 6.675412,-0.071863 1.211574,2.034893 -0.724447,7.980581 -2.660468,2.034893 -8.124307,-0.071863 -2.660468,-2.17862 -0.724447,-8.124307"
        transform="matrix(1.351373 0.003079-.00283 1.241856 14.001556 13.294152)"
        fill="url(#e6yrOKULG4B3-fill)"
        strokeWidth="0"
      />
    </svg>
  );
};

const formatDuration = (time: number) => {
  if (time < 0) {
    return "00:00";
  }
  const durationSeconds = time;
  const durationMinutes = Math.floor(durationSeconds / 60);
  const durationHours =
    durationMinutes >= 60 ? Math.floor(durationMinutes / 60) : "";
  const seconds = durationSeconds % 60;
  const minutes = durationMinutes % 60;
  return durationHours !== ""
    ? `${durationHours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    : `${durationMinutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
};

const useDarkStyles = makeStyles((theme) => ({
  menuPaper: { backgroundColor: "#282828" },
}));
const useLightStyles = makeStyles((theme) => ({
  menuPaper: { backgroundColor: "#fff" },
}));

const menuItemStyle = (mode: string) => ({
  color: mode === "light" ? "black" : "white",
  background: mode === "light" ? "white" : "#333",
  width: 200,
});

const AvailableCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {} as any,
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const BusyCheckbox = withStyles({
  root: {
    color: brown[400],
    "&$checked": {
      color: brown[600],
    },
  },
  checked: {} as any,
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const DNDCheckbox = withStyles({
  root: {
    color: pink[400],
    "&$checked": {
      color: pink[600],
    },
  },
  checked: {} as any,
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const INVCheckbox = withStyles({
  root: {
    color: grey[400],
    "&$checked": {
      color: grey[600],
    },
  },
  checked: {} as any,
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const LateCheckbox = withStyles({
  root: {
    color: blue[400],
    "&$checked": {
      color: blue[600],
    },
  },
  checked: {} as any,
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const navObjects = [
  {
    title: "SAi",
    page: "sai",
    icon: <BlurCircular style={{ fontSize: "1em", color: "#3939bb" }} />,
  },
  {
    title: "Insights",
    page: "c2g",
    icon: <Equalizer style={{ fontSize: "1em" }} />,
  },
  {
    title: "Dashboard",
    page: "hud",
    icon: <Computer style={{ fontSize: "1em" }} />,
  },
  {
    title: "Disposition",
    page: "disposition",
    icon: <List style={{ fontSize: "1em" }} />,
  },

  // {
  //   title: 'RSI Admin Portal',
  //   page: 'management',
  //   icon: <Security style={{ fontSize: '1em' }} />
  // },
  {
    title: "Admin Portal",
    page: "portal",
    icon: <People style={{ fontSize: "1em" }} />,
  },
  {
    title: "Settings",
    page: "settings",
    icon: <SettingsOutlined style={{ fontSize: "1em" }} />,
  },
];
// eslint-disable-next-line arrow-body-style
const NavItem = ({
  isLogOut,
  title,
  setPage,
  page,
  icon,
  mode,
  currentPage,
  setDialer,
  adminClick,
  isPortal,
  resetDialerPosition,
}: {
  isLogOut: boolean;
  title: string;
  setPage: React.Dispatch<SetStateAction<string>>;
  setDialer: React.Dispatch<SetStateAction<boolean>>;
  page: string;
  icon: any;
  mode: string;
  currentPage: string;
  adminClick: () => void;
  isPortal?: boolean;
  resetDialerPosition?: () => void;
}) => {
  const handleAction = () =>
    page === "embeddable"
      ? setDialer((p) => !p)
      : (() => {
          adminClick();
          setPage(page);
        })();

  const handlePageAction = () =>
    isLogOut
      ? (async () => {
          await deleteCookie();
          if ((window as any)?.chrome && (window as any)?.chrome?.webview) {
            (window as any).chrome.webview?.postMessage({
              rec: { event: "DISCONNECTED" },
            });
          }
          window.location.reload();
        })()
      : (() => handleAction())();

        const handleDoubleClick = () => {
          if (title === "Dialer" && resetDialerPosition) {
            resetDialerPosition();
          }
        }

      if (isPortal) return (
        <div
          className={`sa-nav-item ${mode === "light" ? "light" : "dark"}`}
        >
          <IconButton
            id="nav-selector-rsi-portal"
            disableRipple
            onClick={() => window.open("https://www.adminpanel.rsicloud.com/", "_blank")}
            style={{ color: "white" }}
            size="small"
          >
            {icon}
          </IconButton>
          <label
            htmlFor="nav-selector-rsi-portal"
            className={`nav-text ${page === currentPage ? "selected-nav" : ""}`}
          >
            {title}
          </label>
        </div>
      )
  if (title === "Dialer") return (
    <div
      className={`sa-nav-item ${mode === "light" ? "light" : "dark"} ${page === currentPage ? "selected-item" : ""
        }`}
    >
      <Tooltip
        title="Double Click to Reset Dialer Position"
        placement="bottom"
        PopperProps={{
          style: { zIndex: 10000000 }
        }}
      >
        <div>
          <IconButton
            id={`nav-selector-${page}`}
            disableRipple
            onClick={handlePageAction}
            onDoubleClick={handleDoubleClick}
            style={{ color: "white" }}
            size="small"
          >
            {icon}
          </IconButton>
          <label
            htmlFor={`nav-selector-${page}`}
            className={`nav-text ${page === currentPage ? "selected-nav" : ""}`}
            onDoubleClick={handleDoubleClick}
          >
            {title}
          </label>
        </div>
    </Tooltip>
    </div>
  );
  return (
    <div
      className={`sa-nav-item ${mode === "light" ? "light" : "dark"} ${
        page === currentPage ? "selected-item" : ""
      }`}
    >
      <IconButton
        id={`nav-selector-${page}`}
        disableRipple
        onClick={handlePageAction}
        style={{ color: "white" }}
        size="small"
      >
        {icon}
      </IconButton>
      <label
        htmlFor={`nav-selector-${page}`}
        className={`nav-text ${page === currentPage ? "selected-nav" : ""}`}
      >
        {title}
      </label>
    </div>
  );
};

const SAI = ({
  title,
  orgId,
  sai,
  page,
  icon,
  mode,
  currentPage,
  setSai,
}: {
  title: string;
  orgId: string;
  sai: boolean;
  setSai: React.Dispatch<SetStateAction<boolean>>;
  page: string;
  icon: any;
  mode: string;
  currentPage: string;
}) => {
  if (orgId === "3154756020") {
    return (
      <div
        className={`sa-nav-item ${mode === "light" ? "light" : "dark"}`}
        role="button"
        onClick={() => setSai((prev) => !prev)}
      >
        <div className={`sai-container ${mode}`}>
          <div>{mode === "light" ? <SvgLight /> : <SvgDark />}</div>

          <label
            htmlFor={`nav-selector-${page}`}
            className={`nav-text sai-nav ${
              page === currentPage ? "selected-nav" : ""
            }`}
          >
            {title}
          </label>
        </div>
      </div>
    );
  }
  return <></>;
};

const statusBlipGetter = (status: string | undefined): String | undefined => {
  if (status?.startsWith("AVL")) return "AVAILABLE";
  if (status?.startsWith("BSY")) return "BUSY";
  if (status?.startsWith("DND")) return "DND";
  if (status?.startsWith("INV")) return "INVISIBLE";
  return "INVISIBLE";
};

const cxStatusBlipGetter = (status: string | undefined): String | undefined => {
  if (status === "AVAILABLE") return "AVAILABLE";
  if (status === "ENGAGED" || status === "BREAK AFTER CALL" || status === "TRANSITION" || status === "PENDING DISPOSITION" || status === "UKNOWN" || status === "OFF-LINE") return "INVISIBLE";
  if (status === "TRAINING" || status === "WORKING" || status === "ON BREAK" || status === "LUNCH" || status === "AWAY" || status === "RNA STATE") return "YELLOW";
  return "INVISIBLE";
};

const MiniDialer = ({
  mode,
  vipList,
  legacyUI,
  activeCall,
  handleDialerClick,
}: {
  mode: string;
  vipList: any;
  activeCall: any;
  legacyUI: boolean;
  handleDialerClick: (p: string) => void;
}) => {
  const { status, data } = activeCall;
  const [time, setElapsedTime] = useState(0);

  useEffect(() => {
    const calculateElapsedTime = () => {
      const now = Math.floor(Date.now() / 1000);
      const startTime = Math.floor(
        new Date(data?.startTime || 0).getTime() / 1000
      );
      setElapsedTime(now - startTime);
    };
    calculateElapsedTime();
    const intervalId = setInterval(calculateElapsedTime, 1000);
    return () => clearInterval(intervalId);
  }, [data]);

  const getName = () => {
    if (data.from) return data.from;
    if (data.fromNumber) return data.fromNumber;
    return data?.fromUserName || " ";
  };

  return (
    <div className="rc-mini-dialer">
      {legacyUI && (
        <div
          className="rc-mini-dialer-container"
          style={{
            background: mode === "light" ? "#13689e" : "#333",
          }}
        >
          {activeCall && status === "ringing" && (
            <div style={{ minWidth: 50 }}>
              <div
                className="rc-mini-dialer-call-info"
                style={{ display: "flex", alignItems: "center" }}
              >
                <PhoneInTalk
                  fontSize="medium"
                  style={{ color: "white", padding: 5 }}
                />
                <div style={{ display: "block" }}>
                  <div
                    className="rc-mini-dialer-call-info"
                    style={{ padding: "0px 5px", fontWeight: 900 }}
                  >
                    {getName()}
                  </div>
                  <div
                    className="rc-mini-dialer-call-info"
                    style={{ padding: "0px 5px", fontSize: "0.85em" }}
                  >
                    {" "}
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeCall && status === "active" && (
            <div style={{ minWidth: 50 }}>
              <div
                className="rc-mini-dialer-call-info"
                style={{ display: "flex", alignItems: "center" }}
              >
                <PhoneInTalk
                  fontSize="medium"
                  style={{ color: "white", padding: 5 }}
                />
                <div style={{ display: "block" }}>
                  <div
                    className="rc-mini-dialer-call-info"
                    style={{ padding: "0px 5px", fontWeight: 900 }}
                  >
                    {getName()}
                  </div>
                  <div
                    className="rc-mini-dialer-call-info"
                    style={{ padding: "0px 5px", fontSize: "0.85em" }}
                  >
                    {formatDuration(time)}
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeCall && status === "ringing" && (
            <span>
              <Tooltip title="Answer">
                <button
                  className="rc-mini-dialer-button answer"
                  onClick={() => handleDialerClick("answer")}
                  type="button"
                >
                  <Phone fontSize="small" style={{ color: "white" }} />
                </button>
              </Tooltip>
            </span>
          )}
          {activeCall && status === "ringing" && (
            <span>
              <Tooltip title="Voicemail">
                <button
                  className="rc-mini-dialer-button decline "
                  onClick={() => handleDialerClick("toVoicemail")}
                  type="button"
                >
                  <Voicemail fontSize="small" style={{ color: "white" }} />
                </button>
              </Tooltip>
            </span>
          )}
          {activeCall && status === "active" && (
            <span>
              <Tooltip title="End Call">
                <button
                  className="rc-mini-dialer-button decline "
                  onClick={() => handleDialerClick("hangup")}
                  type="button"
                >
                  <CallEnd fontSize="small" style={{ color: "white" }} />
                </button>
              </Tooltip>
            </span>
          )}
          {activeCall && status === "active" && (
            <button
              className="rc-mini-dialer-button mute "
              style={{ backgroundColor: mode === "light" ? "#aaa" : "#717171" }}
              onClick={() =>
                handleDialerClick(data.isOnMute ? "unmute" : "mute")
              }
              type="button"
            >
              {data.isOnMute ? (
                <Tooltip title="Unmute">
                  <MicOff style={{ color: "white" }} />
                </Tooltip>
              ) : (
                <Tooltip title="Mute">
                  <MicRounded style={{ color: "white" }} />
                </Tooltip>
              )}
            </button>
          )}
        </div>
      )}
      {!legacyUI && (
        <div>
          {activeCall && status === "ringing" && (
            <button onClick={() => handleDialerClick("answer")} type="button">
              answer
            </button>
          )}
          {activeCall && status === "ringing" && (
            <button
              onClick={() => handleDialerClick("toVoicemail")}
              type="button"
            >
              decline
            </button>
          )}
          {activeCall && status === "ringing" && (
            <button onClick={() => handleDialerClick("reject")} type="button">
              reject
            </button>
          )}
          {activeCall && status === "active" && (
            <button onClick={() => handleDialerClick("hangup")} type="button">
              hang up
            </button>
          )}
        </div>
      )}
    </div>
  );
};

const Navbar = React.memo(
  ({
    isAdmin,
    mode,
    page,
    setPage,
    setDialer,
    dialer,
    showAvailable,
    showBusy,
    showDnd,
    showInvisible,
    setShowAvailable,
    setShowDnd,
    setShowInvisible,
    setShowBusy,
    mobileNav,
    legacyUI,
    tab,
    setTab,
    orgId,
    setMobileNav,
    setSidebar,
    sidebar,
    showLeaderboards,
    meEx,
    meCx,
    hasCx,
    setProfileId,
    uri,
    rcAccessToken,
    activeCall,
    setActiveCall,
    vipList,
    hasC2G,
    hasDispositionTab,
    hasCustomerPortal,
    sai,
    setSai,
    browserPhone,
    adminclick,
    ivrSummary,
    rcId,
    resetDialerPosition,
  }: {
    isAdmin: boolean;
    mode: string;
    page: string;
    setPage: React.Dispatch<SetStateAction<string>>;
    dialer: boolean;
    showAvailable: boolean;
    showBusy: boolean;
    showDnd: boolean;
    showInvisible: boolean;
    sai: boolean;
    setSai: React.Dispatch<SetStateAction<boolean>>;
    orgId: string;
    setDialer: React.Dispatch<SetStateAction<boolean>>;
    setShowAvailable: React.Dispatch<SetStateAction<boolean>>;
    setShowDnd: React.Dispatch<SetStateAction<boolean>>;
    setShowInvisible: React.Dispatch<SetStateAction<boolean>>;
    setShowBusy: React.Dispatch<SetStateAction<boolean>>;
    legacyUI: boolean;
    showLeaderboards: boolean | undefined;
    mobileNav: boolean;
    tab: string;
    setTab: React.Dispatch<SetStateAction<string>>;
    setMobileNav: React.Dispatch<SetStateAction<boolean>>;
    setSidebar: React.Dispatch<SetStateAction<boolean>>;
    sidebar: boolean;
    meEx: any;
    meCx: CXAgent | undefined;
    hasCx: boolean;
    setProfileId: React.Dispatch<SetStateAction<string | undefined>>;
    uri: string;
    rcAccessToken: string;
    activeCall: any;
    vipList: any;
    setActiveCall: React.Dispatch<SetStateAction<any>>;
    hasC2G: boolean;
    hasDispositionTab: boolean;
    hasCustomerPortal: boolean;
    browserPhone: boolean;
    adminclick: (s: string | undefined) => void;
    ivrSummary: boolean;
    rcId: string;
    resetDialerPosition: () => void;
  }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const classes = mode === "light" ? useLightStyles() : useDarkStyles();
    // console.log("HAS C", hasCx);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleProfileclick = () => {
      setPage("profile");
      setProfileId(meEx.rcId);
    };

    const handleDialerClick = (action: string) => {
      const dialerRef = document.querySelector(
        "#ex-dialer"
      ) as HTMLIFrameElement;
      const postController = () =>
        dialerRef.contentWindow!.postMessage(
          {
            type: "rc-adapter-control-call",
            callAction: action,
          },
          "*"
        );
      if (dialerRef) {
        postController();
        if (action === "answer") {
          setDialer(true);
        }
      }
    };

    React.useEffect(() => {
      if (rcId) {
        const savedTab = localStorage.getItem(`sa-selected-tab-${rcId}`);
        if (savedTab) {
          setTab(savedTab);
        }
      }
    }, [rcId, ivrSummary]);

    const handleTabChange = (newTab: string) => {
      localStorage.setItem(`sa-selected-tab-${rcId}`, newTab);
      setTab(newTab);
    };

    return (
      <>
        {legacyUI ? (
          <>
            <div className="sa-nav-parent">
              <div
                className="sa-nav-container"
                style={{
                  background:
                    mode === "light"
                      ? "linear-gradient(179deg, rgb(4 133 191), rgb(6 132 189))"
                      : "#181818",
                }}
              >
                <div className="left-side-nav">
                  {/* <div id="google_translate_element" /> */}
                  <div className="nav-img-container">
                    <button
                      style={{ border: 0, background: 0 }}
                      type="button"
                      onClick={handleProfileclick}
                    >
                      <img
                        aria-label="portrait"
                        src={
                          uri
                            ? `${uri}?access_token=${rcAccessToken}`
                            : "./default-user-image.ico"
                        }
                        alt="Profile"
                        style={{ borderRadius: "50%", height: 50, width: 50 }}
                        onError={(e: any) => {
                          e.target.src = "./default-user-image.ico";
                        }}
                      />
                    </button>
                    {meEx?.display && (
                      <div
                        className={`status-activity-blip ${statusBlipGetter(
                          meEx?.display || "none"
                        )}`}
                      >
                        <div className="dnd-dash" />
                      </div>
                    )}
                    
                  </div>
                  <h2
                    className="sa-nav-header-text notranslate"
                    style={{
                      color: "white",
                      margin: 0,
                      height: 30,
                      padding: "0px 10px",
                    }}
                  >
                    {" "}
                    Shadow Agent
                  </h2>
                </div>
                <div className="right-side-nav">
                  {activeCall.status && (
                    <MiniDialer
                      mode={mode}
                      vipList={vipList}
                      activeCall={activeCall}
                      legacyUI={legacyUI}
                      handleDialerClick={handleDialerClick}
                    />
                  )}
                  {/* {hasCx && (
                    <Tooltip title="CX HUD">
                      <button
                        onClick={() => {
                          adminclick("");
                          setTab("cx");
                          setPage("hud");
                        }}
                        text-content="CX HUD"
                        type="button"
                        className={`header-nav-button ${
                          page === "hud" && tab === "cx" ? "selected" : ""
                        }`}
                      >
                        <Computer
                          fontSize="small"
                          style={{ color: "white", fontSize: "1.2em" }}
                        />
                      </button>
                    </Tooltip>
                  )} */}
                  {hasC2G && (
                    <Tooltip title="Insights">
                      <button
                        onClick={() => {
                          adminclick("");
                          setPage("c2g");
                        }}
                        text-content="Insights"
                        type="button"
                        className={`header-nav-button ${
                          page === "c2g" ? "selected" : ""
                        }`}
                      >
                        <Equalizer
                          fontSize="small"
                          style={{ color: "white", fontSize: "1.2em" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                  <Tooltip title="HUD">
                    <button
                      onClick={() => {
                        adminclick("");
                        setPage("hud");
                      }}
                      text-content="HUD"
                      type="button"
                      className={`header-nav-button ${
                        page === "hud" ? "selected" : ""
                      }`}
                    >
                      <Computer
                        fontSize="small"
                        style={{ color: "white", fontSize: "1.2em" }}
                      />
                    </button>
                  </Tooltip>
                  {hasDispositionTab && (
                    <Tooltip title="Disposition">
                      <button
                        onClick={() => {
                          adminclick("");
                          setPage("disposition");
                        }}
                        text-content="Call Log"
                        type="button"
                        className={`header-nav-button ${
                          page === "disposition" ? "selected" : ""
                        }`}
                      >
                        <List
                          fontSize="small"
                          style={{ color: "white", fontSize: "1.2em" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                  {browserPhone && (
                    <Tooltip 
                    title={
                      <div style={{ textAlign: "center" }}>
                        Phone<br/>Double Click to Reset Dialer Position
                      </div>
                    }
                    >
                      <button
                        className={`header-nav-button ${
                          dialer ? "selected" : ""
                        }`}
                        onClick={() => {
                          adminclick("");
                          setDialer((p) => {
                            localStorage.setItem(
                              "sa-ex-dialer",
                              JSON.stringify(!p)
                            );
                            return !p;
                          });
                        }}
                        onDoubleClick={() => {
                          // Snap dialer back to ( x: 0, y: 0 )
                          resetDialerPosition();
                        }}
                        text-content={dialer ? "Close Dialer" : "Open Dialer"}
                        type="button"
                      >
                        <Phone
                          fontSize="small"
                          style={{ color: "white", fontSize: "1.2em" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                  {
                    isAdmin && orgId === "1520397020" && (
                      <Tooltip arrow placement="left" style={{zIndex: 99999999999999999}} title={<span>RSI Admin Portal (Shadow Agent Operations) <OpenInNew style={{fontSize: '0.8rem'}}/></span>}>
                        <button
                           onClick={() => window.open("https://www.adminpanel.rsicloud.com/", "_blank")}
                          text-content="Portal"
                          type="button"
                          className={`header-nav-button ${
                            page === "portal" ? "selected" : ""
                          }`}
                        >
                          <Security
                            fontSize="small"
                            style={{ color: "white", fontSize: "1.2em" }}
                          />
                        </button>
                      </Tooltip>
                    )
                  }
                  {hasCustomerPortal && isAdmin && (
                    <Tooltip title="Admin Portal">
                      <button
                        onClick={() => {
                          adminclick("");
                          setPage("portal");
                        }}
                        text-content="Admin Portal"
                        type="button"
                        className={`header-nav-button ${
                          page === "management" ? "selected" : ""
                        }`}
                      >
                        <People
                          fontSize="small"
                          style={{ color: "white", fontSize: "1.2em" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                  <Tooltip title="Settings">
                    <button
                      onClick={() => {
                        adminclick("");
                        setPage("settings");
                      }}
                      text-content="Settings"
                      type="button"
                      className={`header-nav-button ${
                        page === "settings" ? "selected" : ""
                      }`}
                    >
                      <SettingsOutlined
                        fontSize="small"
                        style={{ color: "white", fontSize: "1.2em" }}
                      />
                    </button>
                  </Tooltip>
                  <Tooltip title="Log out">
                    <button
                      onClick={async () => {
                        await deleteCookie();
                        window.location.reload();
                      }}
                      type="button"
                      className="header-nav-button"
                      text-content="Log out"
                    >
                      <Clear
                        fontSize="small"
                        style={{ color: "white", fontSize: "1.2em" }}
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
              {page === "hud" && (
                <div
                  className="sa-nav-container-hud-selectors"
                  style={{ background: mode === "light" ? "white" : "#282828" }}
                >
                  <div className="sa-nav-container-left">
                    <div className="sa-nav-switch-box">
                      <button
                        className={`sa-nav-users-queues-switch ${
                          mode === "light" ? "light" : "dark"
                        }`}
                        type="button"
                        onClick={() =>
                          handleTabChange(tab === "users" ? "queues" : "users")
                        }
                      >
                        <p
                          className={`toggle users-toggle ${
                            tab === "users" ? "selected" : "not-selected"
                          }`}
                        >
                          Users
                        </p>
                        <p
                          className={`toggle queues-toggle ${
                            tab === "queues" ? "selected" : "not-selected"
                          }`}
                        >
                          Queues
                        </p>
                      </button>
                    </div>
                    <div className="sa-nav-container-hud-checkboxes desktop-view">
                      <div>
                        <FormControlLabel
                          control={
                            <AvailableCheckbox
                              checked={showAvailable}
                              onChange={() => setShowAvailable((prev) => !prev)}
                            />
                          }
                          label="Available"
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <BusyCheckbox
                              checked={showBusy}
                              onChange={() => setShowBusy((prev) => !prev)}
                            />
                          }
                          label="Busy"
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <DNDCheckbox
                              checked={showDnd}
                              onChange={() => setShowDnd((prev) => !prev)}
                            />
                          }
                          label="DND"
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <INVCheckbox
                              checked={showInvisible}
                              onChange={() => setShowInvisible((prev) => !prev)}
                            />
                          }
                          label="Invisible"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="sa-nav-container-right desktop-view">
                    <IconButton
                      disableRipple
                      onClick={() => setSidebar((prev) => !prev)}
                    >
                      {sidebar ? (
                        <ArrowForward
                          style={{
                            color: mode === "light" ? "black" : "white",
                          }}
                        />
                      ) : (
                        <ArrowBack
                          style={{
                            color: mode === "light" ? "black" : "white",
                          }}
                        />
                      )}
                    </IconButton>
                  </div>

                  <div className="sa-nav-container-hud-checkboxes mobile-view">
                    <IconButton
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <FilterList
                        style={{ color: mode === "light" ? "black" : "white" }}
                      />
                    </IconButton>
                    <div className="sa-nav-container-right mobile-view">
                      <IconButton
                        disableRipple
                        onClick={() => setSidebar((prev) => !prev)}
                      >
                        {sidebar ? (
                          <ArrowForward
                            style={{
                              color: mode === "light" ? "black" : "white",
                            }}
                          />
                        ) : (
                          <ArrowBack
                            style={{
                              color: mode === "light" ? "black" : "white",
                            }}
                          />
                        )}
                      </IconButton>
                    </div>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      classes={{ paper: classes.menuPaper }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      <MenuItem style={menuItemStyle(mode)}>
                        <FormControlLabel
                          control={
                            <AvailableCheckbox
                              checked={showAvailable}
                              onChange={() => setShowAvailable((prev) => !prev)}
                            />
                          }
                          label="Available"
                        />
                      </MenuItem>
                      <MenuItem style={menuItemStyle(mode)}>
                        <FormControlLabel
                          control={
                            <BusyCheckbox
                              checked={showBusy}
                              onChange={() => setShowBusy((prev) => !prev)}
                            />
                          }
                          label="Busy"
                        />
                      </MenuItem>
                      <MenuItem style={menuItemStyle(mode)}>
                        <FormControlLabel
                          control={
                            <DNDCheckbox
                              checked={showDnd}
                              onChange={() => setShowDnd((prev) => !prev)}
                            />
                          }
                          label="DND"
                        />
                      </MenuItem>
                      <MenuItem style={menuItemStyle(mode)}>
                        <FormControlLabel
                          control={
                            <INVCheckbox
                              checked={showInvisible}
                              onChange={() => setShowInvisible((prev) => !prev)}
                            />
                          }
                          label="Invisible"
                        />
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              )}
            </div>
            {page === "hud" && (
              <div
                className={`hud-buffer-legacy ${
                  showLeaderboards ? "show-leaderboards" : "hidden-leaderboards"
                }`}
              />
            )}
            {page !== "hud" && <div className="else-buffer-legacy" />}
          </>
        ) : (
          <>
            <div className="sa-navbar-parent">
              <div
                className={`sa-navbar-parent-inner ${
                  mode === "light" ? "light" : "dark"
                }`}
              >
                <div className="sa-navbar-left">
                  <div className="nav-img-container">
                    <button
                      style={{ border: 0, background: 0 }}
                      type="button"
                      onClick={handleProfileclick}
                    >
                      <img
                        aria-label="portrait"
                        src={
                          uri
                            ? `${uri}?access_token=${rcAccessToken}`
                            : "./default-user-image.ico"
                        }
                        alt="Profile"
                        style={{ borderRadius: "50%", height: 46, width: 46 }}
                        onError={(e: any) => {
                          e.target.src = "./default-user-image.ico";
                        }}
                      />
                    </button>
                    {meEx?.display && (
                      <div
                        className={`status-activity-blip blip-new ${hasCx && meCx?.agentState && (tab === "cx" || tab === "cx-queues") ? cxStatusBlipGetter(meCx?.agentState || "none") : statusBlipGetter(meEx?.display || "none")}`}
                      >
                        <div className="dnd-dash" />
                      </div>
                    )}
                  </div>
                  <h2 className="sa-title-text notranslate">Shadow Agent</h2>
                </div>
                <div className="sa-navbar-right">
                  {/* SAi */}
                  <SAI
                    orgId={orgId}
                    title="SAi"
                    page={page}
                    setSai={setSai}
                    sai={sai}
                    icon={<BlurCircular style={{ fontSize: "1em", color: "#3939bb" }} />}
                    mode={mode}
                    currentPage={page}
                  />
                  {/* DIALLER */}
                  {browserPhone && (
                      <NavItem
                        isLogOut={false}
                        title="Dialer"
                        page="embeddable"
                        icon={ <Phone style={{ fontSize: "1em" }} />}
                        setPage={setPage}
                        setDialer={setDialer}
                        mode={mode}
                        currentPage={page}
                        adminClick={() => setProfileId(undefined)}
                        resetDialerPosition={resetDialerPosition}
                      />
                    )
                   }
                  {/* CRADLE 2 GRAVE / INSIGHTS */}
                  {hasC2G && (
                    <NavItem
                     isLogOut={false}
                     title="Insights"
                     page="c2g"
                     icon={<Equalizer style={{ fontSize: "1em" }} />}
                     setPage={setPage}
                     setDialer={setDialer}
                     mode={mode}
                     currentPage={page}
                     adminClick={() => setProfileId(undefined)}
                   />
                  )}
                  {/*  HUD */}
                  <NavItem
                    isLogOut={false}
                    title="Dashboard"
                    page="hud"
                    icon={<Computer style={{ fontSize: "1em" }} />}
                    setPage={setPage}
                    setDialer={setDialer}
                    mode={mode}
                    currentPage={page}
                    adminClick={() => setProfileId(undefined)}
                   />
                  {/* DISPOSITION PAGE */}
                   {hasDispositionTab && (
                    <NavItem
                      isLogOut={false}
                      title="Disposition"
                      page="disposition"
                      icon={ <List style={{ fontSize: "1em" }} />}
                      setPage={setPage}
                      setDialer={setDialer}
                      mode={mode}
                      currentPage={page}
                      adminClick={() => setProfileId(undefined)}
                    />
                    )
                   }
                   {
                    orgId === "1520397020" && (
                      <>
                        <NavItem
                          isLogOut={false}
                          title="RSI Portal"
                          page="portal"
                          icon={<Business style={{ fontSize: "1em" }} />}
                          setPage={setPage}
                          setDialer={setDialer}
                          mode={mode}
                          currentPage={page}
                          adminClick={() => setProfileId(undefined)}
                          isPortal
                    />

                      </>
                    )
                   }
                    {hasCustomerPortal && isAdmin && (
                    <NavItem
                      isLogOut={false}
                      title="Admin Portal"
                      page="portal"
                      icon={<People style={{ fontSize: "1em" }} />}
                      setPage={setPage}
                      setDialer={setDialer}
                      mode={mode}
                      currentPage={page}
                      adminClick={() => setProfileId(undefined)}
                    />
                    )
                   }
                   <NavItem
                      isLogOut={false}
                      title="Settings"
                      page="settings"
                      icon={<SettingsOutlined style={{ fontSize: "1em" }} />}
                      setPage={setPage}
                      setDialer={setDialer}
                      mode={mode}
                      currentPage={page}
                      adminClick={() => setProfileId(undefined)}
                    />
                  <NavItem
                    isLogOut
                    title="Log Out"
                    page="Log out"
                    icon={<Clear />}
                    setPage={setPage}
                    setDialer={setDialer}
                    mode={mode}
                    currentPage={page}
                    adminClick={() => setProfileId(undefined)}
                  />
                </div>
              </div>
              {page === "hud" && (
                <div
                  className={`sa-navbar-subbar hud-subbar ${
                    mode === "light" ? "light" : "dark"
                  }`}
                >
                  <div className="sa-navbar-subbar-selectors">
                    {/* {
                      hasCx && <PersonOutline style={{marginRight: 20}} />
                    } */}
                    <button
                      className={`sa-selector-tab ${
                        tab === "users" ? "selected-nav" : ""
                      } ${mode === "light" ? "light" : "dark"}`}
                      type="button"
                      onClick={() => handleTabChange("users")}
                    >
                      Users
                    </button>
                    <button
                      className={`sa-selector-tab ${
                        tab === "queues" ? "selected-nav" : ""
                      } ${mode === "light" ? "light" : "dark"}`}
                      type="button"
                      onClick={() => handleTabChange("queues")}
                    >
                      Queues
                    </button>
                    {ivrSummary && (
                      <>
                        <button
                          className={`notranslate sa-selector-tab ${
                            tab === "ivr" ? "selected-nav" : ""
                          } ${mode === "light" ? "light" : "dark"}`}
                          type="button"
                          onClick={() => handleTabChange("ivr")}
                        >
                          IVR
                        </button>
                        <button
                          className={`notranslate sa-selector-tab ${
                            tab === "air" ? "selected-nav" : ""
                          } ${mode === "light" ? "light" : "dark"}`}
                          type="button"
                          onClick={() => handleTabChange("air")}
                        >
                          AIR
                        </button>
                      </>
                    )}
                    {orgId === "3154756020" && (
                        <button
                          className={`notranslate sa-selector-tab ${
                            tab === "live" ? "selected-nav" : ""
                          } ${mode === "light" ? "light" : "dark"}`}
                          type="button"
                          onClick={() => handleTabChange("live")}
                        >
                         <FiberManualRecordTwoTone fontSize="small" width="10px" height="10px" style={{color: 'red'}} /> Live
                        </button>
                      )
                    }
                    {hasCx && (
                      <>
                        <span className="selector-divider"  >
                             {/* <PeopleOutline /> */}
                        </span>
                          <button
                            className={`sa-selector-tab ${
                              tab === "cx" ? "selected-nav" : ""
                            } ${mode === "light" ? "light" : "dark"}`}
                            type="button"
                            onClick={() => handleTabChange("cx")}>
                            <PeopleOutline style={{color: mode === 'light' ? "#888" : "#888"}} fontSize="small" />  Agents 
                          </button>
                          <button
                            className={`sa-selector-tab ${
                              tab === "cx-queues" ? "selected-nav" : ""
                            } ${mode === "light" ? "light" : "dark"}`}
                            type="button"
                            onClick={() => handleTabChange("cx-queues")}>
                              <PeopleOutline style={{color: mode === 'light' ? "#888" : "#888"}}fontSize="small" /> Queues 
                          </button>
                        </>
                      )
                    } 
                  </div>
                  <div className="sa-navbar-subbar-sidebar-container">
                    <IconButton
                      disableRipple
                      onClick={() => setSidebar((prev) => !prev)}
                    >
                      {sidebar ? (
                        <ArrowForward
                          style={{
                            color: mode === "light" ? "black" : "white",
                          }}
                        />
                      ) : (
                        <ArrowBack
                          style={{
                            color: mode === "light" ? "black" : "white",
                          }}
                        />
                      )}
                    </IconButton>
                  </div>
                </div>
              )}
              {page !== "hud" && <div className="sa-navbar-subbar" />}
            </div>
            {page === "hud" && (
              <div
                className={`hud-buffer ${
                  showLeaderboards ? "show-leaderboards" : "hidden-leaderboards"
                }`}
              />
            )}
            {page !== "hud" && (
              <div
                className={`else-buffer ${
                  showLeaderboards ? "show-leaderboards" : "hidden-leaderboards"
                }`}
              />
            )}
          </>
        )}
      </>
    );
  }
);

export default Navbar;
